import * as React from 'react';

import type {ChatbotToneEnum} from 'nutshell-graphql-types';

import {StackLegacy} from '../layout/stack/stack-legacy';
import {Body} from '../typography/body';

import styles from './chat-preview.module.css';

type Props = {
    name: string;
    tone: ChatbotToneEnum;
    icon: React.ComponentType<any> | null | undefined;
};

const getMessage = (name: string, tone: ChatbotToneEnum) => {
    switch (tone) {
        case 'FRIENDLY':
            return `Hey there! I'm ${name}, your friendly chatbot assistant. How can I help you today?`;
        case 'NEUTRAL':
            return `Greetings. I am ${name}, your virtual assistant. How may I be of service to you?`;
        case 'PROFESSIONAL':
        default:
            return `Hello, my name is ${name} and I'm here to assist you.`;
    }
};

export function ChatbotContent(props: Props) {
    const Icon = props.icon;

    return (
        <StackLegacy spacing={4}>
            <StackLegacy isHorizontal={true} spacing={6} alignCenter={true}>
                {Icon ? <Icon size={14} alignCenter={true} /> : undefined}
                <Body size='mini'>{props.name}</Body>
            </StackLegacy>
            <div className={styles['chat-bubble--outgoing']}>
                {getMessage(props.name, props.tone)}
            </div>
        </StackLegacy>
    );
}
